import React from "react";
import ServicesMain from "./Main/ServicesMain";
import ServicesList from "./ServicesList/ServicesList";

const Services = () => {
  return (
    <div className="__sweven_services">
      <ServicesMain />
      <ServicesList />
    </div>
  );
};

export default Services;
